function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 135,
  height: 40,
  rx: 7,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M68.136 21.751c-2.352 0-4.269 1.79-4.269 4.253 0 2.45 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253-.001-2.464-1.918-4.253-4.27-4.253zm0 6.832c-1.289 0-2.4-1.063-2.4-2.578 0-1.53 1.112-2.578 2.4-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.578-2.4 2.578zm-9.314-6.832c-2.352 0-4.269 1.79-4.269 4.253 0 2.45 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253 0-2.464-1.917-4.253-4.27-4.253zm0 6.832c-1.289 0-2.4-1.063-2.4-2.578 0-1.53 1.112-2.578 2.4-2.578 1.289 0 2.4 1.047 2.4 2.578.001 1.514-1.111 2.578-2.4 2.578zm-11.078-5.526v1.804h4.318c-.129 1.015-.467 1.756-.983 2.271-.628.628-1.611 1.321-3.335 1.321-2.658 0-4.736-2.143-4.736-4.8 0-2.659 2.078-4.802 4.736-4.802 1.434 0 2.481.564 3.254 1.29l1.273-1.274c-1.08-1.03-2.513-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605 0 3.641 3.061 6.605 6.702 6.605 1.965 0 3.448-.645 4.607-1.853 1.192-1.192 1.563-2.868 1.563-4.22 0-.419-.032-.806-.097-1.128h-6.073v.001zm45.308 1.401c-.354-.95-1.434-2.707-3.641-2.707-2.191 0-4.012 1.724-4.012 4.253 0 2.384 1.805 4.253 4.221 4.253 1.949 0 3.077-1.192 3.545-1.885l-1.45-.967c-.483.71-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.289l5.687-2.352-.193-.482zm-5.8 1.418c-.048-1.644 1.273-2.48 2.224-2.48.741 0 1.369.37 1.579.901l-3.803 1.58zM82.629 30h1.868V17.5h-1.868V30zm-3.062-7.298h-.064c-.419-.5-1.225-.95-2.239-.95-2.127 0-4.076 1.868-4.076 4.27 0 2.383 1.949 4.236 4.076 4.236 1.015 0 1.82-.45 2.239-.966h.064v.612c0 1.627-.87 2.497-2.271 2.497-1.144 0-1.853-.82-2.143-1.514l-1.627.677c.467 1.127 1.707 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.43V22.01h-1.772v.692h-.001zm-2.142 5.881c-1.289 0-2.368-1.08-2.368-2.562 0-1.499 1.079-2.594 2.368-2.594 1.272 0 2.271 1.095 2.271 2.594 0 1.482-.999 2.562-2.271 2.562zM101.806 17.5h-4.471V30H99.2v-4.736h2.605c2.068 0 4.102-1.497 4.102-3.882s-2.033-3.883-4.101-3.883zm.048 6.025H99.2V19.24h2.654c1.395 0 2.187 1.155 2.187 2.143 0 .968-.792 2.142-2.187 2.142zm11.532-1.795c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.69 1.014-.917 1.705-.917.965 0 1.946.58 1.962 1.608v.13c-.338-.194-1.062-.483-1.946-.483-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.254 0 1.946-.563 2.38-1.223h.064v.965h1.802v-4.793c.001-2.218-1.657-3.456-3.795-3.456zm-.226 6.851c-.61 0-1.463-.306-1.463-1.062 0-.965 1.062-1.335 1.979-1.335.819 0 1.206.177 1.704.418a2.262 2.262 0 01-2.22 1.98zm10.583-6.578l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.946l5.131-11.789h-2.075zM106.937 30h1.865V17.5h-1.865V30zM47.418 10.243c0 .838-.248 1.505-.745 2.003-.564.592-1.3.888-2.204.888-.866 0-1.603-.3-2.208-.9-.606-.601-.91-1.345-.91-2.233 0-.89.304-1.633.91-2.233.605-.601 1.342-.901 2.208-.901.43 0 .84.084 1.23.25.392.169.705.392.939.67l-.527.529c-.397-.475-.944-.712-1.643-.712-.632 0-1.178.222-1.64.666-.46.444-.69 1.02-.69 1.73 0 .709.23 1.286.69 1.73a2.282 2.282 0 001.64.666c.67 0 1.229-.223 1.676-.67.29-.291.458-.696.503-1.215h-2.18V9.79h2.908c.03.157.043.308.043.453zM52.028 7.737h-2.732v1.902h2.464v.721h-2.464v1.902h2.732V13h-3.503V7h3.503v.737zM55.279 13h-.772V7.737h-1.675V7h4.123v.737h-1.676V13zM59.938 13V7h.77v6h-.77zM64.128 13h-.771V7.737H61.68V7h4.123v.737h-1.676V13zM73.608 12.225c-.59.606-1.323.909-2.2.909-.877 0-1.61-.303-2.199-.909-.59-.606-.884-1.348-.884-2.225s.294-1.619.884-2.225c.59-.606 1.322-.91 2.2-.91.871 0 1.603.305 2.195.914.592.609.888 1.349.888 2.221 0 .877-.295 1.619-.884 2.225zm-3.83-.503a2.2 2.2 0 001.63.674c.643 0 1.187-.225 1.63-.674.444-.45.667-1.024.667-1.722s-.223-1.272-.667-1.722a2.199 2.199 0 00-1.63-.674c-.643 0-1.186.225-1.63.674-.443.45-.666 1.024-.666 1.722s.223 1.272.666 1.722zM75.575 13V7h.938l2.915 4.667h.034l-.034-1.156V7h.772v6h-.806l-3.05-4.894h-.033l.032 1.156V13h-.769z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.418 10.243c0 .838-.248 1.505-.745 2.003-.564.592-1.3.888-2.204.888-.866 0-1.603-.3-2.208-.9-.606-.601-.91-1.345-.91-2.233 0-.89.304-1.633.91-2.233.605-.601 1.342-.901 2.208-.901.43 0 .84.084 1.23.25.392.169.705.392.939.67l-.527.529c-.397-.475-.944-.712-1.643-.712-.632 0-1.178.222-1.64.666-.46.444-.69 1.02-.69 1.73 0 .709.23 1.286.69 1.73a2.282 2.282 0 001.64.666c.67 0 1.229-.223 1.676-.67.29-.291.458-.696.503-1.215h-2.18V9.79h2.908c.03.157.043.308.043.453zM52.028 7.737h-2.732v1.902h2.464v.721h-2.464v1.902h2.732V13h-3.503V7h3.503v.737zM55.279 13h-.772V7.737h-1.675V7h4.123v.737h-1.676V13zM59.938 13V7h.77v6h-.77zM64.128 13h-.771V7.737H61.68V7h4.123v.737h-1.676V13zM73.608 12.225c-.59.606-1.323.909-2.2.909-.877 0-1.61-.303-2.199-.909-.59-.606-.884-1.348-.884-2.225s.294-1.619.884-2.225c.59-.606 1.322-.91 2.2-.91.871 0 1.603.305 2.195.914.592.609.888 1.349.888 2.221 0 .877-.295 1.619-.884 2.225zm-3.83-.503a2.2 2.2 0 001.63.674c.643 0 1.187-.225 1.63-.674.444-.45.667-1.024.667-1.722s-.223-1.272-.667-1.722a2.199 2.199 0 00-1.63-.674c-.643 0-1.186.225-1.63.674-.443.45-.666 1.024-.666 1.722s.223 1.272.666 1.722zM75.575 13V7h.938l2.915 4.667h.034l-.034-1.156V7h.772v6h-.806l-3.05-4.894h-.033l.032 1.156V13h-.769z",
  stroke: "#fff",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#google-play_svg__filter0_ii)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.436 7.538c-.291.308-.463.786-.463 1.405v22.116c0 .62.172 1.097.463 1.405l.074.072 12.389-12.389v-.292l-12.39-12.39-.073.073z",
  fill: "url(#google-play_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.027 24.278l-4.129-4.131v-.292l4.13-4.13.093.053 4.893 2.78c1.397.794 1.397 2.093 0 2.888l-4.893 2.78-.094.052z",
  fill: "url(#google-play_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#google-play_svg__filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.122 24.225l-4.224-4.224-12.463 12.463c.46.488 1.221.548 2.079.062l14.608-8.301z",
  fill: "url(#google-play_svg__paint2_linear)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.122 15.777l-14.608-8.3c-.857-.487-1.618-.426-2.079.062l12.463 12.463 4.224-4.225z",
  fill: "url(#google-play_svg__paint3_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play_svg__paint0_linear",
  x1: 21.8,
  y1: 8.709,
  x2: 5.018,
  y2: 25.491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play_svg__paint1_linear",
  x1: 33.833,
  y1: 20.001,
  x2: 9.637,
  y2: 20.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play_svg__paint2_linear",
  x1: 24.828,
  y1: 22.295,
  x2: 2.069,
  y2: 45.053,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play_svg__paint3_linear",
  x1: 7.297,
  y1: 0.177,
  x2: 17.459,
  y2: 10.339,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})), /*#__PURE__*/React.createElement("filter", {
  id: "google-play_svg__filter0_ii",
  x: 9.973,
  y: 7.141,
  width: 23.09,
  height: 25.721,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "google-play_svg__filter1_i",
  x: 10.435,
  y: 20.001,
  width: 16.686,
  height: 12.861,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})));

var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgGooglePlay;